// @ts-ignore
import {HttpClient} from '@angular/common/http';
// @ts-ignore
import {Injectable} from '@angular/core';
// @ts-ignore
import {Observable,forkJoin, map} from 'rxjs';
import {SankhyaEnvelope} from './sankhya-gateway.service';

import {
    LocalEstoque, LocaisResponse, ProdutoEstoque, ProdutosResponse,
    TransferenciaPayload, TransferenciaResponse, ImagemResponse,
    ProdutoBusca, ProdutosBuscaResponse, LocalProduto, LocaisProdutoResponse
} from '../models/estoque.model';

// @ts-ignore
@Injectable({
    providedIn: 'root'
})
export class EstoqueService {
    private readonly apiUrl = '/api/sankhya/estoque';

    constructor(private readonly http: HttpClient) {
    }

    buscarLocais(): Observable<SankhyaEnvelope<LocaisResponse>> {
        return this.http.post<SankhyaEnvelope<LocaisResponse>>(`${this.apiUrl}/locais`, {});
    }

    buscarProdutosPorLocal(codLocal: number): Observable<SankhyaEnvelope<ProdutosResponse>> {
        return this.http.post<SankhyaEnvelope<ProdutosResponse>>(`${this.apiUrl}/produtos-por-local`, {CODLOCAL: codLocal});
    }

    transferir(payload: TransferenciaPayload): Observable<SankhyaEnvelope<TransferenciaResponse>> {
        return this.http.post<SankhyaEnvelope<TransferenciaResponse>>(`${this.apiUrl}/transferir`, payload);
    }

    buscarImgProduto(codProd: number): Observable<SankhyaEnvelope<ImagemResponse>> {
        return this.http.post<SankhyaEnvelope<ImagemResponse>>(`${this.apiUrl}/imagem-produto`, {CODPROD: codProd});
    }

    buscarProdutos(termo: string): Observable<SankhyaEnvelope<ProdutosBuscaResponse>> {
        // Requisição 1: Busca apenas por REFFORN
        const reqRefforn = this.http.post<SankhyaEnvelope<ProdutosBuscaResponse>>(
            `${this.apiUrl}/buscar-produtos`,
            { "REFFORN": termo, "DESCRICAO": "" }
        );

        // Requisição 2: Busca apenas por DESCRICAO
        const reqDescricao = this.http.post<SankhyaEnvelope<ProdutosBuscaResponse>>(
            `${this.apiUrl}/buscar-produtos`,
            { "REFFORN": "", "DESCRICAO": termo }
        );

        // Executa ambas em paralelo e combina os resultados
        // @ts-ignore
        return forkJoin([reqRefforn, reqDescricao]).pipe(
            map(([resRefforn, resDescricao]) => {
                // Extrai as listas de cada resposta (tratando possíveis nulos/indefinidos)
                const listaRefforn = resRefforn?.responseBody?.lista || [];
                const listaDescricao = resDescricao?.responseBody?.lista || [];

                // Une as duas listas
                const listaCombinada = [...listaRefforn, ...listaDescricao];

                // Remove duplicados garantindo itens únicos pelo código do produto
                const listaUnica = listaCombinada.filter((produto, index, self) =>
                        index === self.findIndex((p) =>
                            (p.codprod && p.codprod === produto.codprod) ||
                            (p.codigo && p.codigo === produto.codigo)
                        )
                );

                // Monta o envelope de retorno idêntico ao original para não quebrar o Component
                return {
                    ...resRefforn, // Mantém os metadados de status/envelope da primeira resposta
                    responseBody: {
                        ...resRefforn?.responseBody,
                        lista: listaUnica
                    }
                };
            })
        );
    }

    buscarLocaisDoProduto(codProd: number, codEmp?: number): Observable<SankhyaEnvelope<LocaisProdutoResponse>> {
        return this.http.post<SankhyaEnvelope<LocaisProdutoResponse>>(`${this.apiUrl}/buscar-locais-produto`, {CODPROD: codProd, CODEMP: codEmp});
    }

    importarEstoqueCsv(payload: any[]): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/importar-csv`, {rows: payload});
    }

    // ── Importação 3 tabelas ─────────────────────────────────────────────────
    importarBase(rows: any[]): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/importar-base`, {rows});
    }

    importarForms(rows: any[]): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/importar-forms`, {rows});
    }

    importarSeriais(rows: any[]): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/importar-seriais`, {rows});
    }

    previewNota(): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/preview-nota`, {});
    }

    executarNota(params: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/executar-nota`, params);
    }

    executarNotaEmpresa(params: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/executar-nota-empresa`, params);
    }

    iniciarNotaEmpresa(params: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/iniciar-nota-empresa`, params);
    }

    processarLoteItens(params: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/processar-lote-itens`, params);
    }

    finalizarNotaEmpresa(params: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/finalizar-nota-empresa`, params);
    }

    // ── Nota de Correção (tela Comparação de Estoque) ───────────────────────
    // processarLoteItens (acima) é reaproveitado pro passo 2/3 do fluxo de
    // correção -- é o mesmo job em memória no addon.

    iniciarNotaCorrecao(params: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/iniciar-nota-correcao`, params);
    }

    finalizarNotaCorrecao(params: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/finalizar-nota-correcao`, params);
    }
}
